export type TabType =
  | 'search'
  | 'index'
  | 'workflows'
  | 'automations'
  | 'realtime'
  | 'playground'
  | 'engines'
  | 'marked'
  | 'connectors'
  | 'webhooks'
  | 'apikeys'
  | 'usage'
  | 'jobs'
  | 'billing'
  | 'mcp'
  | 'profile';

export const TAB_PATHS: Record<TabType, string> = {
  search: '/search',
  index: '/index',
  workflows: '/workflows',
  automations: '/automations',
  realtime: '/realtime',
  playground: '/playground',
  engines: '/engines',
  marked: '/marked',
  connectors: '/connectors',
  webhooks: '/webhooks',
  apikeys: '/apikeys',
  usage: '/usage',
  jobs: '/jobs',
  billing: '/billing',
  mcp: '/mcp',
  profile: '/profile',
};

export const DEFAULT_TAB: TabType = 'playground';

const TAB_BY_PATH = new Map<string, TabType>(
  (Object.entries(TAB_PATHS) as Array<[TabType, string]>).map(([tab, path]) => [path, tab])
);

export const isTabType = (value: string | null | undefined): value is TabType => {
  return !!value && Object.prototype.hasOwnProperty.call(TAB_PATHS, value);
};

export const getTabPath = (tab: TabType): string => TAB_PATHS[tab];

export const getTabFromPathname = (pathname: string): TabType | null => {
  const normalized = pathname === '/' ? '/' : pathname.replace(/\/+$/, '');
  if (normalized === '/') return null;
  // Routes in App are exact top-level routes. Treating an arbitrary nested
  // path as a known tab made the sidebar identify one destination while the
  // router's wildcard immediately redirected to another.
  return TAB_BY_PATH.get(normalized) ?? null;
};

export const isKnownTabPath = (pathname: string): boolean => getTabFromPathname(pathname) !== null;
